module.exports = __webpack_public_path__ + "img/bubbles2.30136c7d.png";